<template>
  <div v-if="$can('view-finance-details', 'Yacht')">
    <v-row
      no-gutters
      justify="center"
    >
      <v-col cols="10">
        <div class="mb-12">
          <finance-details-cash-flow
            :yacht="yacht"
            direction="inbound"
            @update:yacht="$emit('update:yacht')"
          />
        </div>

        <div class="mb-16">
          <finance-details-cash-flow
            :yacht="yacht"
            direction="outbound"
            @update:yacht="$emit('update:yacht')"
          />
        </div>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import FinanceDetailsCashFlow from '@/components/business/yachts/FinanceDetailsCashFlow.vue'

export default {
  name: 'FinanceDetails',
  components: { FinanceDetailsCashFlow },
  props: {
    yacht: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
    }
  },
  computed: {
  },
  watch: {
  },
  created() {
  },
  methods: {
  }
}
</script>

<style scoped>

</style>
